<template lang="pug">
  .flow-builder-action-find-product
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white
        p.mb-0 Buscar producto
        p.text-secondary.text-sm Permite buscar un producto en el catálogo, usando inteligencia artificial o buscando el texto idéntico.
        result-description.mb-3(variable-name="product", variable-type="object")
        fieldset.mb-1(:disabled="disabled")
          b-form-group.mb-1(label-size="sm", label="Tipo de búsqueda:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'search_type'")
            b-form-select(size="sm", :options="searchTypes" :value="template_attribute.value || null", @change="update(template_attribute, $event)")
              template(#first)
                b-form-select-option(:value="null", disabled ) -- Selecciona búsqueda --
          b-form-group.mb-1(label-size="sm", label="Texto a buscar:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'text'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Texto a buscar", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label-size="sm", label="Categoría a buscar:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'category_id'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Categoría a buscar", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group(label-size="sm", label="Límite de resultados:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'limit'")
            b-form-select(size="sm", :options="limitOptions(10)" :value="template_attribute.value || null", @change="update(template_attribute, $event)")
              template(#first)
                b-form-select-option(:value="null", disabled ) -- Selecciona límite --
      template-connector(v-for="connector in Template_Connectors", :key="connector.template_connector_id", v-bind="connector", :block_id="block_id", :disabled="disabled")
</template>

<script>
import ResultDescription from '@/components/templates/helpers/ResultDescription.vue'
import templateCommon from '@/helpers/template-common'
import Connector from '@/components/templates/connectors/Connector.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import _debounce from 'lodash.debounce'

export default {
  mixins: [templateCommon],
  data () {
    return {
      searchTypes: [
        { text: 'Básica', value: 'basic' },
        { text: 'Inteligente', value: 'ai' }
      ]
    }
  },
  components: {
    ResultDescription,
    'template-connector': Connector,
    TemplateTools
  },
  methods: {
    update (template_attribute, value) {
      template_attribute.value = value
      const attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value

      this.updateAttribute(this.block_id, this.template_id, attribute)

      this.$message.success('Actualizado')
    },
    limitOptions (limit = 10) {
      let array = []
      for (let i = 1; i <= limit; i++) {
        array.push({
          text: i,
          value: i
        })
      }
      return array
    }
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      const newValue = value.target._value

      this.update(template_attribute, newValue)

      this.$message.success('Actualizado')
    }, 100, { leading: false, trailing: true })
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-action-find-product {
    position: relative;
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
  }
</style>
